import { Injectable } from '@angular/core';
import { timeout } from 'rxjs';
import { CertificateDataRepository } from '../../../core/data/repositories/certificatedata.repository';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';
import { TestDataRepository } from '../../../core/data/repositories/testdata.repository';
import { CertificateDetails } from '../model/certificate-details';
import { CertificateInformation } from '../model/certificate-information';
import { TestGoalResult } from '../../test/model/test-result';
import { CertiticateFilterDTO } from '../model/certificate-filter';

@Injectable()
export class CertificateService {
  cerInformation: CertificateInformation = {
    cerDetails: {} as CertificateDetails,
    certId: 0,
    projectId: 0,
    testId: 0,
    isEdit: false,
    result: [],
    cerElements: [],
    documents: [],
    isUserCanEdit: false,
    isUserMaster: false
  };

  constructor(
    private masterDataRepository: MasterDataRepository,
    private certificateDataRepository: CertificateDataRepository,
    private tstDataRepository: TestDataRepository
  ) { }

  getCertificateInformation(id: number): CertificateInformation {
    if (id > 0) {
      this.certificateDataRepository.getCertificateDetails(id).subscribe({
        next: (x: any) => {
          if (x.value) {
            this.cerInformation.cerDetails = x.value;
            this.cerInformation.isUserCanEdit = x.bag.canEdit;
            this.cerInformation.isUserMaster = x.bag.isAdminMaster;
            this.cerInformation.projectId = x.value.projectId;
            this.cerInformation.cerDetails.cerCheckDate = this.cerInformation.cerDetails.cerCheckDate != null ? new Date(this.cerInformation.cerDetails.cerCheckDate) : null;
            this.cerInformation.cerDetails.cerExpiryDate1 = this.cerInformation.cerDetails.cerExpiryDate1 != null ? new Date(this.cerInformation.cerDetails.cerExpiryDate1) : null;
            this.cerInformation.cerDetails.certificateDate1 = this.cerInformation.cerDetails.certificateDate1 != null ? new Date(this.cerInformation.cerDetails.certificateDate1) : null;
          }
        },
      });
    }
    return this.cerInformation;
  }

  getCertificateInfo(id: number) {
    if (id > 0) {
      return new Promise<CertificateInformation>((resolve) => {
        this.certificateDataRepository.getCertificateDetails(id).subscribe(
          (x: any) => {
            if (x.value) {
              this.cerInformation.cerDetails = x.value;
              this.cerInformation.projectId = x.value.projectId;
              this.cerInformation.cerDetails.cerCheckDate = this.cerInformation.cerDetails.cerCheckDate ? new Date(this.cerInformation.cerDetails.cerCheckDate) : null;
              this.cerInformation.cerDetails.cerExpiryDate1 = this.cerInformation.cerDetails.cerExpiryDate ? new Date(this.cerInformation.cerDetails.cerExpiryDate) : null;
              this.cerInformation.cerDetails.certificateDate1 = this.cerInformation.cerDetails.certificateDate ? new Date(this.cerInformation.cerDetails.certificateDate) : null;
              resolve(this.cerInformation);
            }

          },
          (error) => {
            resolve(this.cerInformation);
          }
        );
      });
    }
  }

  setCertificateInformation(
    cInformation: CertificateInformation,
    reset: boolean = false
  ) {
    if (reset)
      this.cerInformation = {
        cerDetails: {} as CertificateDetails,
        certId: 0,
        projectId: 0,
        testId: 0,
        isEdit: false,
        result: [],
        cerElements: [],
        documents: [],
        isUserCanEdit: false,
        isUserMaster: false
      };
    else this.cerInformation = cInformation;
  }

  getInstiteLocation(instituteType: number) {
    return this.masterDataRepository.getInstiteLocByType(instituteType);
  }

  getInstituteLoc(includeInactive: boolean) {
    return this.masterDataRepository.getInstituteLoc(includeInactive);
  }

  getTstSponsors(partnrTyp: number) {
    return this.masterDataRepository.getPartnerByType(partnrTyp);
  }

  getInstituteType() {
    return this.masterDataRepository.getInstituteType();
  }

  getCountryReg() {
    return this.masterDataRepository.getCountryAndRegions();
  }
  getCerTypes() {
    return this.masterDataRepository.getCertificateType();
  }
  //test page project dd
  getProjectList() {
    return this.masterDataRepository.getProjectList();
  }
  getMyOpenProjectList() {
    return this.masterDataRepository.getGetMyOpenProject();
  }
  getNorms(type: number) {
    return this.masterDataRepository.getStanardsByModule(3, type);
  }
  getCertificates(id: number) {
    return this.masterDataRepository.getCertificateList(id);
  }

  getCheckedBy() {
    return this.certificateDataRepository.getCertificateCheckedBy();
  }
  //#region Dasboard
  getAllCertificates(query) {
    return this.certificateDataRepository.getAllCertificatesDetails(query);
  }
  //#endregion Dasboard

  getTestList(prjId: number) {
    return this.masterDataRepository.getTestList(prjId);
  }
  getCertificateDetails(id: number) {
    return this.certificateDataRepository.getCertificateDetails(id);
  }
  getCertificateOverview(pId: number) {
    return this.certificateDataRepository.getCertificateOverview(pId);
  }
  setCertificateDetails(data: CertificateDetails): any {
    let id: number = 0;
    let result: any;
    return new Promise<any>((resolve) => {
      this.certificateDataRepository.saveCertificateDetails(data)
        .subscribe(
          (data: any) => {
            result = data;
            resolve(result);
          },
          (error) => {
            resolve(null);
          }
        );
    });
    //return this.certificateDataRepository.saveCertificateDetails(data);
  }

  setResult(data: any[]): any {
    this.cerInformation.result = [];
    data.forEach((val: any) => {
      val.certificateId = this.cerInformation.certId;
      this.certificateDataRepository
        .saveResults(val)
        //.pipe(timeout(500))
        .subscribe({
          next: (result: any) => {
            if (val.id !== 0) result = val;
            this.cerInformation.result.push(result);
          },
          error: (error) => {
            console.log(error);
          },
        });
    });
  }

  setElement(data: any): any {
    let id: number = 0;
    const observable$ = this.certificateDataRepository.saveElement(data);
    observable$.subscribe({
      next: (result) => {
        if (result) data.id = result;
        if (this.cerInformation.cerElements.indexOf(data) == -1)
          this.cerInformation.cerElements.push(data);
        //return this.cerInformation.cerElements;
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
  setDocuments(data: any[]): any {
    let result: boolean = false;
    data.forEach((value) => {
      value.certId = this.cerInformation.certId;
    });
    this.certificateDataRepository.saveDocuments(data).subscribe(
      (result: any[]) => {
        this.cerInformation.documents = result;
        return result;
      },
      (error) => {
        console.log(error);
        return error;
      }
    );
  }

  getResult(id: number) {
    return this.certificateDataRepository.getCertificateResult(id);
  }

  getPerformanceCrtiterian(testId: number) {
    return this.masterDataRepository.getPerformanCriterian(3, testId);
  }
  getResultUnit() {
    return this.masterDataRepository.getResultUnit();
  }

  setGoalResult(data: any[]): any {

    //data.forEach((val: any) => {
    return this.certificateDataRepository.saveGoalresult(data);
    //});
  }
  deleteResult(ids: number[], elementId): any {
    return this.certificateDataRepository.deletePerformance(ids, elementId);
  }
  getSearch(data: CertiticateFilterDTO) {
    return this.certificateDataRepository.search(data);
  }
  
    getExportSearch(data: CertiticateFilterDTO) {
      return this.certificateDataRepository.export(data);
    }
  

  copyCertificate(id: number, projectId: number) {
    var model = { 'ProjectId': projectId, 'CertificateId': id }
    return this.certificateDataRepository.copy(model);
  }

  deleteCertificate(id: number, projectId: number) {
    return this.certificateDataRepository.deleteCertificate(id, projectId);
  }
}
